import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TransactionsDetailComponent } from './transactions-detail/transactions-detail.component';
import { TransactionsListComponent } from './transactions-list/transactions-list.component';
import { TransactionsWorkersComponent } from './transactions-workers/transactions-workers.component';
import { TransactionsWorkersBusinessComponent } from './transactions-workers-business/transactions-workers-business.component';
import { TransactionsRetentionsComponent } from './transactions-retentions/transactions-retentions.component';
import { TransactionsWorkerBillableItemsComponent } from './transactions-workers-billable-items-lines/transactions-workers-billable-items-lines.component';

const routes: Routes = [
    {
        path: 'transactions/worker-billable-items-lines',
        children: [
            { path: '', component: TransactionsWorkerBillableItemsComponent }
        ]
    },  
    {
        path: 'transactions-retentions',
        children: [
            { path: '', component: TransactionsRetentionsComponent }
        ]
    },  
    {
        path: 'transactions/:type',
        children: [
            { path: '', component: TransactionsListComponent }
        ]
    },  
    {
        path: 'transactions/:type/transactions-workers/incoming_invoice',
        children: [
            { path: '', component: TransactionsWorkersComponent },
            { path: ':transactionId', component: TransactionsWorkersComponent }
        ]
    },
    {
        path: 'transactions/:type/transactions-workers-business',
        children: [
            { path: '', component: TransactionsWorkersBusinessComponent }
        ]
    }
    ,{
        path: 'transactions/:type/:id',
        children: [
            { path: '', component: TransactionsDetailComponent }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TransactionsRoutingModule { }
